import React from "react";

export const LOGO_STYLE: React.CSSProperties = {
  fontFamily: 'DM sans, sans-serif',
  color: '#1f6de2',
  fontWeight: 500,
};